import RemoteVideoComponent from "./RemoteVideoComponent";

export default RemoteVideoComponent;